export default __webpack_public_path__ + "static/media/ai01.fb50a5d7.png";